// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mvWvN","tabsBox":"styles_tabsBox__1XZuc","createButton":"styles_createButton__3MoAJ"};